// Minimaler GPX-Parser (client-side, ohne Node-Abhängigkeiten).
// Browser hat DOMParser; Node-Server kann auch via fast-xml-parser oder DOMParser-Polyfill.
export function parseGpx(xml, opts) {
    const doc = opts.domParser.parseFromString(xml, 'application/xml');
    const trks = Array.from(doc.getElementsByTagName('trk'));
    const tracks = [];
    for (const trk of trks) {
        const nameEl = trk.getElementsByTagName('name')[0];
        const name = nameEl?.textContent?.trim();
        const points = [];
        const segs = Array.from(trk.getElementsByTagName('trkseg'));
        for (const seg of segs) {
            const pts = Array.from(seg.getElementsByTagName('trkpt'));
            for (const p of pts) {
                const lat = parseFloat(p.getAttribute('lat') || 'NaN');
                const lon = parseFloat(p.getAttribute('lon') || 'NaN');
                if (!Number.isFinite(lat) || !Number.isFinite(lon))
                    continue;
                const eleEl = p.getElementsByTagName('ele')[0];
                const timeEl = p.getElementsByTagName('time')[0];
                const ele = eleEl?.textContent ? parseFloat(eleEl.textContent) : undefined;
                const time = timeEl?.textContent?.trim() || undefined;
                points.push({ lat, lon, ele, time });
            }
        }
        tracks.push({ name, points });
    }
    return tracks;
}
// GeoJSON-LineString aus einem Track — direkt in MapLibre als Source nutzbar.
export function trackToGeoJson(track) {
    return {
        type: 'Feature',
        properties: { name: track.name ?? '' },
        geometry: {
            type: 'LineString',
            coordinates: track.points.map((p) => [p.lon, p.lat, p.ele ?? 0]),
        },
    };
}
